import { MYQAMPUS_FEATURE_NAMES } from '@/src/constants/feature-name-constants.js'
let ROUTE_CONSTANTS = {
  DASHBOARD: {
    ID: '2',
    NAME: 'DASHBOARD',
    PATH: 'dashboard',
    ROUTE_NAME: 'dashboard',
    ICON: 'dashboard',
  },
  QUICK_ACTION: {
    ID: '3',
    NAME: 'QUICK_ACTIONS',
    PATH: 'quick-actions',
    ICON: 'quickAction',
  },
  NOTIFICATION_PREFERENCES: {
    ID: '29',
    NAME: 'NOTIFICATION_PREFERENCES',
    PATH: { name: 'notification-preferences' },
  },
  CAMPUSES: {
    ID: '4',
    NAME: 'CAMPUSES',
    PATH: 'campuses',
    ICON: 'campuse',
  },
  ATTENDANCE: {
    ID: '5',
    NAME: 'ATTENDANCE',
    PATH: 'attendance',
    ICON: 'attendance',
    CAMPUS: {
      ID: '5.1',
      NAME: MYQAMPUS_FEATURE_NAMES.STUDENTS_CAMPUS_ATTENDANCE,
      PATH: 'student-campus-attendance',
    },
    SECTION: {
      ID: '5.2',
      NAME: MYQAMPUS_FEATURE_NAMES.STUDENTS_SECTION_ATTENDANCE,
      PATH: 'student-section-attendance',
      MARK: {
        ID: '5.2.1',
        NAME: 'MARK_SECTION_STUENT_ATTENDANCE',
        PATH: { name: 'mark-student-section-attendance' },
      },
      DETAIL: {
        ID: '5.2.2',
        NAME: 'STUDENTS_SECTION_ATTENDANCE_DETAIL',
        PATH: 'student-section-attendance-detail',
      },
    },
    DAILY_STUDENT_ATTENDANCE: {
      ID: '5.3',
      NAME: 'DAILY_STUDENT_ATTENDANCE',
      PATH: 'daily-student-attendance',
    },
    DAILY_STAFF_ATTENDANCE: {
      ID: '5.4',
      NAME: 'DAILY_STAFF_ATTENDANCE',
      PATH: 'daily-staff-attendance',
    },
    PERIOD: {
      ID: '5.5',
      NAME: MYQAMPUS_FEATURE_NAMES.STUDENTS_PERIOD_ATTENDANCE,
      PATH: 'students-period-attendance',
    },
    STAFF: {
      ID: '5.6',
      NAME: MYQAMPUS_FEATURE_NAMES.STAFF_CAMPUS_ATTENDANCE,
      PATH: 'staff-campus-attendance',
    },
  },
  TIME_TABLE: {
    ID: '6',
    NAME: MYQAMPUS_FEATURE_NAMES.TIME_TABLE_MANAGER,
    PATH: 'time-table',
    ICON: 'timeTable',
    AUTOMATOR: {
      ID: '6.1',
      NAME: 'TIME_TABLE_AUTOMATOR',
      PATH: 'time-table-automator',
    },
    CURRENT: {
      ID: '6.2',
      NAME: 'CURRENT_TIME_TABLE',
      PATH: 'current-time-table',
    },
    MY_TIMETABLE: {
      ID: '6.3',
      NAME: 'MY_TIMETABLE',
      PATH: 'my-timetable',
    },

    STUDENT_BIRTHDAYS: {
      ID: '6.4.1',
      NAME: 'STUDENT_BIRTHDAYS',
      PATH: 'student-birthdays',
    },
    STAFF_BIRTHDAYS: {
      ID: '6.4',
      NAME: 'STAFF_BIRTHDAYS',
      PATH: 'staff-birthdays',
    },
    LESSON_PLANNER: {
      ID: '6.5',
      NAME: 'LESSON_PLANNER',
      PATH: 'lesson-planner',
    },
  },
  CLASSES: {
    ID: '7',
    NAME: 'CLASSES',
    DISPLAY_NAME: 'CLASSES',
    PATH: 'classes',
    ICON: 'class',
  },
  USERS: {
    ID: '8',
    NAME: 'ADMIN_USERS',
    ICON: 'users',
    SUPER_ADMIN: {
      ID: '8.1',
      NAME: 'SUPER_ADMIN',
      PATH: 'super-admin',
    },
    CAMPUS_ADMIN: {
      ID: '8.2',
      NAME: 'CAMPUS_ADMIN',
      PATH: 'campus-admin',
    },
    STAFF: {
      ID: '8.3',
      NAME: 'STAFF',
      PATH: 'staff',
    },
    TEACHERS: {
      ID: '8.4',
      NAME: 'TEACHERS',
      PATH: 'teachers',
    },
    STUDENTS: {
      ID: '8.5',
      NAME: 'STUDENTS',
      PATH: 'students',
    },
    GUARDIANS: {
      ID: '8.6',
      NAME: 'GUARDIANS',
      PATH: 'guardians',
    },
    PICKUP_PERSONS: {
      ID: '8.7',
      NAME: 'STUDENT_PICKUP_PERSONS',
      PATH: 'pickup-person',
    },
    ALL_USERS: {
      ID: '8.8',
      NAME: 'ALL_USERS',
      PATH: 'all-users',
    },
  },
  TEACHER_USERS: {
    ID: '20',
    ICON: 'users',
    NAME: 'TEACHER_USERS',
    STUDENT: {
      ID: '20.1',
      NAME: 'TEACHER_STUDENTS',
      PATH: 'teacher-students',
    },
  },
  ROOMS: {
    ID: '9',
    NAME: 'ROOMS',
    PATH: 'rooms',
    ICON: 'room',
  },
  SECTIONS: {
    ID: '10',
    NAME: 'SECTIONS',
    PATH: 'sections',
    DISPLAY_NAME: 'SECTIONS',
    ICON: 'section',
  },
  SALARIES: {
    ID: '11',
    ICON: 'expenseManager',
    NAME: 'FINANCE',
    PATH: 'salaries',
  },
  LESSON_TYPES: {
    ID: '12',
    NAME: 'LESSON_TYPES',
    PATH: 'lesson-types',
    ICON: 'lessonPlanner',
  },
  SYLLABUS_MANAGER: {
    ID: '13',
    NAME: MYQAMPUS_FEATURE_NAMES.SYLLABUS_MANAGER,
    PATH: 'syllabus',
    ICON: 'lessonPlanner',
    SYLLABUS_TEMPLATE_PROVIDER: {
      ID: '15.1',
      NAME: 'SYLLABUS_TEMPLATE_PROVIDER',
      PATH: 'subject-syllabus-template-course',
    },
    SUBJECT_SYLLABUS_TEMPLATE: {
      ID: '15.2',
      NAME: 'SUBJECT_SYLLABUS_TEMPLATE',
      PATH: 'subject-syllabus-template',
    },
    DETAIL_VIEW: {
      ID: '15.3',
      NAME: 'TEMP_DETAIL_VIEW',
      PATH: 'subject-syllabus-template-detail-view',
    },
    IMPORT_CLONE: {
      ID: '15.4',
      NAME: 'IMPORT/CLONE',
      PATH: 'subject-syllabus-template-import',
    },

    SUBJECTS: {
      ID: '13.1',
      NAME: 'SUBJECTS',
      PATH: 'subjects',
    },
    CHAPTERS: {
      ID: '13.2',
      NAME: 'CHAPTERS',
      PATH: 'chapters',
    },
    TOPICS: {
      ID: '13.3',
      NAME: 'TOPICS',
      PATH: 'topics',
    },
    LESSONS: {
      ID: '13.4',
      NAME: 'LESSONS',
      PATH: 'lessons',
    },
  },
  ASSIGNMENT: {
    ID: '14',
    ICON: 'assignment',
    NAME: MYQAMPUS_FEATURE_NAMES.ASSIGNMENT,
    PATH: 'assignment',

    ASSIGNMENT_TYPES: {
      ID: '14.1',
      NAME: 'ASSIGNMENT_TYPES',
      PATH: 'assignment-types',
    },
    ASSIGNMENTS: {
      ID: '14.2',
      NAME: 'ASSIGNMENTS',
      PATH: 'assignmens-view',
    },
    ASSIGNMENTS_DETAILS: {
      ID: '14.3',
      NAME: 'ASSIGNMENTS_DETAILS',
      PATH: 'assignmens-detail-view',
    },
  },
  FEE_MANAGER: {
    ID: '16',
    ICON: 'expenseManager',
    NAME: MYQAMPUS_FEATURE_NAMES.FEE_MANAGER,
    PATH: 'receivable',
    FEE_TYPES: {
      ID: '16.1',
      NAME: 'FEE_TYPES',
      PATH: 'fee-types',
    },
    PAYABLE: {
      ID: '16.2',
      NAME: 'PAYABLE',
      PATH: 'payable',
    },
    RECEIVABLE: {
      ID: '16.3',
      NAME: 'RECEIVABLE',
      PATH: 'receivable',
    },
    PAID: {
      ID: '16.4',
      NAME: 'PAID',
      PATH: 'student-paid',
    },
    RECEIVED: {
      ID: '16.5',
      NAME: 'RECEIVED',
      PATH: 'received',
    },
    ACCEPT_PAYMENT: {
      ID: '16.6',
      NAME: 'ACCEPT_PAYMENT',
      PATH: 'accept-payment',
    },
    SECTION_FEE: {
      ID: '16.7',
      NAME: 'SECTION_FEE',
      PATH: 'section',
    },
    MONTHLY_FEE_GENERATOR: {
      ID: '16.8',
      NAME: 'MONTHLY_FEE_GENERATOR',
      PATH: 'monthly-fee-generator',
    },

    DISCOUNT_TYPES: {
      ID: '16.9',
      NAME: 'DISCOUNT_TYPES',
      PATH: 'discount-types',
    },
    STUDENT_DISCOUNT_LIST: {
      ID: '16.10',
      NAME: 'STUDENT_DISCOUNT_LIST',
      PATH: 'student-discounts',
    },
    STUDENT_DISCOUNT_DETAIL: {
      ID: '16.11',
      NAME: 'STUDENT_DISCOUNT_DETAIL',
      PATH: 'student-discounts-detail',
    },
  },
  PICKUP_ACTIVE_REQUESTS: {
    ID: '20',
    ICON: 'pickup',
    NAME: 'PICKUP_ACTIVE_REQUEST',
    PATH: 'facility-active-request',
  },
  PICKUP_ALL_REQUESTS: {
    ID: '21',
    ICON: 'pickup',
    NAME: 'PICKUP_ALL_REQUEST',
    PATH: 'facility-all-requests',
  },
  PICKUP_REQUEST_MANAGER: {
    ID: '17',
    NAME: MYQAMPUS_FEATURE_NAMES.PICKUP_MANAGER,
    ICON: 'pickup',
    FACILITY_ACTIVE_REQUESTS: {
      ID: '17.1',
      NAME: 'FACILITY_ACTIVE_REQUESTS',
      PATH: 'facility-active-request',
    },
    FACILITY_ALL_REQUESTS: {
      ID: '17.2',
      NAME: 'FACILITY_ALL_REQUESTS',
      PATH: 'facility-all-requests',
    },
  },
  SUPPORT_QUERY: {
    ID: '18',
    ICON: 'supportQuery',
    NAME: MYQAMPUS_FEATURE_NAMES.SUPPORT_QUERY,
    SUPPORT_QUERY_TYPES: {
      ID: '18.1',
      NAME: 'SUPPORT_QUERY_TYPES',
      PATH: 'support-query-types',
    },
    SUPPORT_QUERY: {
      ID: '18.2',
      NAME: 'SUPPORT_QUERY',
      PATH: 'support-query',
    },
  },
  ANNOUNCEMENTS: {
    ID: '19',
    NAME: MYQAMPUS_FEATURE_NAMES.ANNOUNCEMENTS,
    ICON: 'announcement',
    TYPES: {
      ID: '19.1',
      NAME: 'ANNOUNCEMENT_TYPES',
      PATH: 'announcement-types',
    },
    VIEW: {
      ID: '19.2',
      NAME: 'ANNOUNCEMENTS',
      PATH: 'announcement',
    },
    DETAIL: {
      ID: '19.3',
      NAME: 'ANNOUNCEMENT_DETAIL',
      PATH: 'announcement-detail',
    },
  },
  // FEATURE_SETTINGS: {
  //   ID: '20',
  //   ICON: 'lessonPlanner',
  //   NAME: 'FEATURE_SETTINGS',
  // CLASS:
  //     {ID: '20.1',
  //       NAME: 'CLASS',
  //       PATH: 'class-feature-settings',
  //     },
  //    SECTION: {
  //       ID: '20.2',
  //       NAME: 'SECTION',
  //       PATH: 'section-feature-settings' ,
  //     },
  //     STUDENT: {
  //       ID: '20.3',
  //       NAME: 'STUDENT',
  //       PATH: 'student-feature-settings' ,
  //     },
  //     TEACHER:{
  //       ID: '20.4',
  //       NAME: 'TEACHER',
  //       PATH: 'teacher-feature-settings' ,
  //     },
  //     STAFF:{
  //       ID: '20.5',
  //       NAME: 'STAFF',
  //       PATH: 'staff-feature-settings' ,
  //     },
  //     GUARDIAN:{

  //       name: 'GUARDIAN',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'guardian-feature-settings' },
  //     },
  //     {
  //       name: 'PICKUP_PERSON',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'pickup-person-feature-settings' },
  //     },
  //     {
  //       name: 'CAMPUS_ATTENDANCE',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'campus-attendance-feature-settings' },
  //     },
  //     {
  //       name: 'PERIOD_ATTENDANCE',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'period-attendance-feature-settings' },
  //     },
  //     {
  //       name: 'SECTION_ATTENDANCE',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'section-attendance-feature-settings' },
  //     },
  //     {
  //       name: 'FEE',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'fee-feature-settings' },
  //     },
  //     {
  //       name: 'LESSON_PLANNER',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'lesson-planner-feature-settings' },
  //     },
  //     {
  //       name: 'TIME_TABLE',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'time-table-feature-settings' },
  //     },
  //     {
  //       name: 'SYLLABUS_AUTOMATOR',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'syllabus-automator-feature-settings' },
  //     },

  //     {
  //       name: 'SYLLABUS_MANAGER',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'syllabus-feature-settings' },
  //     },
  //     {
  //       name: 'SCHEDULE',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'schedule-feature-settings' },
  //     },

  //     {
  //       name: 'EXAM',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'exam-feature-settings' },
  //     },
  //     {
  //       name: 'EXAM_PLANNER',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'exam-planner-feature-settings' },
  //     },
  //     {
  //       name: 'PICKUP_SETTINGS',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'pickup-feature-settings' },
  //     },
  //     {
  //       name: 'SUPPORT_QUERY',
  //       basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
  //       route: { name: 'support-query-feature-settings' },
  //     },
  // },
  EXPENSE_MANAGER: {
    ID: '21',
    NAME: 'EXPENSE_MANAGER',
    ICON: 'expenseManager',
    EXPENSE_CATEGORIES: {
      ID: '21.1',
      NAME: 'EXPENSE_CATEGORIES',
      PATH: 'categories',
    },
    EXPENSES: {
      ID: '21.2',
      NAME: 'EXPENSES',
      PATH: 'expenses',
    },
  },
  EXAMS_MANAGER: {
    ID: '23',
    ICON: 'exam',
    NAME: MYQAMPUS_FEATURE_NAMES.EXAMS_MANAGER,
    EXAM_TYPES: {
      ID: '23.1',
      NAME: 'EXAM_TYPES',
      PATH: 'exam-types',
    },
    EXAM: {
      ID: '23.2',
      NAME: 'EXAM',
      PATH: 'exams',
    },
    EXAM_DETAILS: {
      ID: '23.3',
      NAME: 'EXAM_DETAILS',
      PATH: 'exams-detail-view',
    },
    EXAM_RESULT_VIEW: {
      ID: '23.4',
      NAME: 'EXAM_RESULT_VIEW',
      PATH: 'exam-result-view',
    },
  },
  EXAMS: {
    ID: '24',
    ICON: 'examPlanner',
    NAME: 'EXAMS',
    EXAM: {
      ID: '24.1',
      NAME: 'EXAM',
      PATH: 'exams',
    },
    EXAM_DETAILS: {
      ID: '24.2',
      NAME: 'EXAM_DETAILS',
      PATH: 'exams-detail-view',
      isDynamicRoute: true,
    },
    EXAMS_RESULT_VIEW: {
      ID: '24.3',
      NAME: 'EXAMS_RESULT_VIEW',
      PATH: 'exam-result-view',
    },
    SUBJECT_RESULT: {
      ID: '24.4',
      NAME: 'SUBJECT_RESULT',
      PATH: 'subject-result',
    },
    SUBJECTS_RESULT_DETAIL: {
      ID: '24.5',
      NAME: 'Subject Result detail',
      PATH: 'subject-result-detail',
    },
    SUBJECT_RESULT_VIEW: {
      ID: '24.6',
      NAME: 'SUBJECT_RESULT_VIEW',
      PATH: 'subject-result-view',
    },
    FINAL_RESULT: {
      ID: '24.7',
      NAME: 'FINAL_RESULT',
      PATH: 'final-result',
    },
    STUDENT_PERFORMANCE: {
      ID: '24.8',
      NAME: 'STUDENT_PERFORMANCE',
      PATH: 'performance-chart',
    },
    FINAL_EXAMS_RESULT_DETAIL: {
      ID: '24.9',
      NAME: 'FINAL_EXAMS_RESULT_DETAIL',
      PATH: { name: 'final-result-detail' },
    },
    STUDENT_RESULT_DETAIL: {
      ID: '24.10',
      NAME: 'STUDENT_RESULT_DETAIL',
      PATH: 'final-result-detail-view',
    },
  },
  GRADES_MANAGER: {
    ID: '25',
    ICON: 'result',
    NAME: MYQAMPUS_FEATURE_NAMES.GRADES_MANAGER,
    NON_GPA_GRADE: {
      ID: '22.1',
      NAME: 'NON_GPA_GRADE',
      PATH: 'non-gpa-grading-structure',
    },
    NON_GPA_GRADE_DETAIL: {
      ID: '22.2',
      NAME: 'NON_GPA_GRADE_DETAIL',
      PATH: 'non-gpa-grading-structure-detail-view',
    },
    GPA_GRADE: {
      ID: '22.3',
      NAME: 'GPA_GRADE',
      PATH: 'gpa-grading-structure',
    },
    GPA_GRADE_DETAIL: {
      ID: '22.4',
      NAME: 'GPA_GRADE_DETAIL',
      PATH: 'gpa-grading-structure-detail-view',
    },
    SUBJECT_RESULT: {
      ID: '25.1',
      NAME: 'SUBJECT_RESULT',
      PATH: 'subject-result',
    },
    SUBJECT_RESULT_DETAIL: {
      ID: '25.2',
      NAME: 'SUBJECT_RESULT_DETAIL',
      PATH: 'subject-result-detail',
    },
    SUBJECT_RESULT_VIEW: {
      ID: '25.3',
      NAME: 'SUBJECT_RESULT_VIEW',
      PATH: 'subject-result-view',
    },
    SECTION_EXAMS_RESULT: {
      ID: '25.4',
      NAME: 'SECTION_EXAMS_RESULT',
      PATH: 'section-result',
    },
    SECTION_EXAMS_RESULT_DETAIL: {
      ID: '25.5',
      NAME: 'SECTION_EXAMS_RESULT_DETAIL',
      PATH: 'section-result-detail-view',
    },
    STUDENT_RESULT_DETAIL: {
      ID: '25.6',
      NAME: 'STUDENT_RESULT_DETAIL',
      PATH: 'exam-student-result',
    },
    SECTION_RESULT_VIEW: {
      ID: '25.7',
      NAME: 'SECTION_RESULT_VIEW',
      PATH: 'section-result-view',
      isDynamicRoute: true,
    },
  },
  SALARY_MANAGER: {
    ID: '26',
    ICON: 'expenseManager',
    NAME: 'SALARY_MANAGER',
    SALARIES: {
      ID: '26.1',
      NAME: 'SALARIES',
      PATH: 'salaries',
    },
    ALLOWANCE_TYPE: {
      ID: '26.2',
      NAME: 'ALLOWANCE_TYPE',
      PATH: 'allowence-type',
    },
    DEDUCTION_TYPE: {
      ID: '26.3',
      NAME: 'DEDUCTION_TYPE',
      PATH: 'deduction-type',
    },
    BONUSES_TYPE: {
      ID: '26.4',
      NAME: 'BONUSES_TYPE',
      PATH: 'bonuses-type',
    },
    EXTRA_WORKING_UNIT: {
      ID: '26.5',
      NAME: 'EXTRA_WORKING_UNIT',
      PATH: 'extra-working-unit',
    },
    SALARY_GENERATOR: {
      ID: '26.6',
      NAME: 'SALARY_GENERATOR',
      PATH: 'salary-generator',
    },
    SALARY_TEMPLATE: {
      ID: '26.7',
      NAME: 'SALARY_TEMPLATE',
      PATH: 'salary-template',
    },
  },
  STUDENT_DISPATCHER: {
    ID: '27',
    NAME: 'STUDENT_DISPATCHER',
    ICON: 'pickup',
    routesName: ['support-active-request', 'support-all-requests'],
  },
  REGISTRATION_PROCESS: {
    ID: '28',
    ICON: 'announcement',
    NAME: 'REGISTRATION_PROCESS',
    REDIRECT: 'registration',
    REGISTRATION: {
      ID: '28.1',
      NAME: 'REGISTRATION',
      PATH: 'registration-list',
    },
    FORM_GENERATOR: {
      ID: '28.2',
      NAME: 'FORM_GENERATOR',
      PATH: 'form-generator',
    },
  },
  NOTICE_BOARD: {
    ID: '29',
    NAME: 'NOTICE_BOARD',
    PATH: 'notice-board',
    ICON: 'announcement',
    VIEW: {
      ID: '29.1',
      NAME: 'NOTICE_BOARD_VIEW',
      PATH: 'notice-board-view',
    },
    LABELS: {
      ID: '29.2',
      NAME: 'NOTICE_BOARD_POST_LABELS',
      PATH: 'notice-board-labels',
    },
  },

  subjectAttendance: {
    path: 'subject-attendance',
    teacher: {
      path: 'teacher',
      name: 'myattendance',
    },
    student: {
      path: 'students',
      name: 'studentAttendance',
      mark: {
        path: 'students/mark',
        name: 'studentMarkAttendance',
      },
    },
  },

  attendance: {
    path: 'attendance',
  },
  schedule: { name: 'schedule' },
  profile: { name: 'my-profile' },
  PICKUP_MANAGER: { ID: '30', NAME: 'PICKUP_MANAGER', PATH: 'pickup-manager' },
}
export default ROUTE_CONSTANTS

// export const updateRoutesList = (routes) => {
//   ROUTE_CONSTANTS.routes = routes
// }

// response.list
// newaction(list)

// newaction (list)
// transformList(response.list )

// import ROUTE_CONSTANTS,updateRoutesList
// list

// updateRoutesList(updated )

// if updated => get
